let lenisInstance = null;

export const setLenis = (lenis) => {
    lenisInstance = lenis;
};

export const getLenis = () => lenisInstance;

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisInstance) {
        lenisInstance.scrollTo(el, { offset: -64, duration: 1.5 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
